export const _state = {
    activeCompanyId: 0,
};

export function appReducer(state = _state, action) {

    switch (action.type) {

        case 'SET_ACTIVE_COMPANY_ID':
            return {
                ...state,
                activeCompanyId: action.payload.companyId,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/app.js